import { render, staticRenderFns } from "./SchooltypesList.vue?vue&type=template&id=01720d79&scoped=true&"
import script from "./SchooltypesList.vue?vue&type=script&lang=ts&"
export * from "./SchooltypesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01720d79",
  null
  
)

export default component.exports